import isObject from "./isObject.js";
import { nativeKeys, hasEnumBug } from "./_setup.js";
import has from "./_has.js";
import collectNonEnumProps from "./_collectNonEnumProps.js";
export default function keys(obj) {
  if (!isObject(obj)) return [];
  if (nativeKeys) return nativeKeys(obj);
  var keys2 = [];
  for (var key in obj) if (has(obj, key)) keys2.push(key);
  if (hasEnumBug) collectNonEnumProps(obj, keys2);
  return keys2;
}
